export const MEDICATION_EXTRACTION_FAILURE_KINDS = [
    "error",
    "no_medications"
];
/** Reason text stored on a job that read the photos and found nothing. */
export const NO_MEDICATIONS_FOUND_MESSAGE = "No medications could be identified in the photos. Try again with new photos.";
/** Reason text stored on a job whose pipeline broke. */
export const EXTRACTION_ERROR_MESSAGE = "Medication extraction failed. Please try again.";
export function isMedicationExtractionFailureKind(value) {
    return (typeof value === "string" &&
        MEDICATION_EXTRACTION_FAILURE_KINDS.includes(value));
}
//# sourceMappingURL=medication-extraction.js.map